
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';



export const subscriptionService = {
  getSubList,
  getMasterData,
  updateItemTableHeader,
  submitBulkAction,
  submitSubscription,
  getSubscription,
  getCustomer,
  updateSubBillingDate,
  submitSalesOrderSubscription,
  beneficiaryList,
  createNewBeneficiary,
  subscriptionByDate,
  subscriptionSearch,
  getSubscriptionAddress,
};




async function  getSubList() {
   return apiClient.get(`/subscriptions/get-subscriptions-list`,authHeader())
}

function getCustomer(customer_id){
 return  apiClient.get(`/get-single-customer/${customer_id}`, authHeader())
   
     }

async function updateSubBillingDate(body){
 return  apiClient.put(`/subscriptions/update-sub-billing-date`, body, authHeader());
   
     }

async function createNewBeneficiary(body){
 return  apiClient.put(`/subscriptions/new-beneficiary`, body, authHeader());
   
     }


async function  getMasterData() {
   return apiClient.get(`/subscriptions/get-master-data`,authHeader())
}
async function  getSubscription(id) {
   return apiClient.get(`/subscriptions/get-subscription/${id}`,authHeader())
}

function updateItemTableHeader(xmlString){
   var body = {xml_string : xmlString}
   return apiClient.put('/subscriptions/update-table-header', body,authHeader())
        
 }
function submitBulkAction(body){
   return apiClient.post('/subscriptions/submit-bulk-action', body,authHeader())     
 }

function submitSubscription(body){
   return apiClient.post('/subscriptions/submit-subscription', body,authHeader())    
 }     


function beneficiaryList(customer_id){
   return apiClient.get(`/subscriptions/beneficiary-list/${customer_id}`,authHeader())    
 }   
 
function submitSalesOrderSubscription(body){
   return apiClient.post('/subscriptions/submit-sales-order-subscription', body,authHeader())
 }  
 
 async function  subscriptionSearch(searchText) {
     return  apiClient.get(`/subscriptions/subscription-search?search=${searchText}`, authHeader());
 }
 
 
 async function  subscriptionByDate(form) {
     return  apiClient.post(`/subscriptions/subscription-by-date`, form, authHeader());
 }


async function getSubscriptionAddress(id) {
  return apiClient.get(`/subscriptions/subscription-address/${id}`, authHeader());
}

 
 










